import { TransformWrapper, TransformComponent } from 'react-zoom-pan-pinch';
import './styles.scss';
import { MapSvg } from './components/mapSvg';

const isMobile = window.innerWidth < 768;
const isTablet = window.innerWidth >= 768 && window.innerWidth < 1024;
const mapConfigResponsive = () => {
  if (isMobile) {
    return {
      initialScale: 1,
      minScale: 1,
      maxScale: 4,
      initialPositionX: -343,
      initialPositionY: 61,
    };
  }
  if (isTablet) {
    return {
      initialScale: 1.4,
      minScale: 1.4,
      maxScale: 4,
      initialPositionX: -343,
      initialPositionY: 61,
    };
  }

  return {
    initialScale: 1.4,
    minScale: 1.4,
    maxScale: 4,
    initialPositionX: 128,
  };
};

export const Map = ({ showDistanceCircles }) => {
  return (
    <div className="vi-tri-map">
      <TransformWrapper
        {...mapConfigResponsive()}
        wheel={{
          step: 0.05,
        }}
        centerZoomedOut
        disablePadding
      >
        <TransformComponent>
          <MapSvg showDistanceCircles={showDistanceCircles} />
        </TransformComponent>
      </TransformWrapper>
    </div>
  );
};
